<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ tax ? $t('edit_tax') : $t('add_tax') }}
      v-spacer
      v-btn(icon @click="hideDialog" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.pa-8
      .mb-4.text-md.font-semibold Fill the information below
      .text-sm.font-semibold.neutral500--text.mb-2 Tax name
      v-text-field.round-xl.mb-4(v-model="name" placeholder="Enter tax name" outlined hide-details dense height=48)
      .text-sm.font-semibold.neutral500--text.mb-2 Rate
      v-row
        v-col(cols="3")
          v-text-field.round-xl.mb-4(v-model="rate" placeholder="0" outlined hide-details suffix="%" type="number" dense height=48)
      .text-sm.font-semibold.neutral500--text.mb-2 Description
      v-text-field.round-xl.mb-4(v-model="description" placeholder="Enter tax description" outlined hide-details dense height=48)
    v-divider

    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="hideDialog" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="tax ? save() : confirm()" :loading="isLoading" color="primary" depressed :disabled="disabledButton") {{ tax ? $t('save') : $t('confirm') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AddEditTaxDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    tax: {
      type: Object
    },
    inputName: {
      type: String
    }
  },
  data: () => ({
    isLoading: false,
    name: null,
    rate: null,
    description: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    disabledButton () {
      return !this.name || !this.rate || !this.description
    }
  },
  mounted () {
    if (this.tax) {
      this.name = this.tax.name
      this.rate = this.tax.rate
      this.description = this.tax.description
    } else if (this.inputName) {
      this.name = this.inputName
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    hideDialog () {
      this.showDialog = false
    },
    confirm () {
      this.isLoading = true
      const payload = {
        company: this.company.id,
        name: this.name,
        description: this.description,
        rate: this.rate
      }
      this.$axios.post('/tax_rates', payload)
        .then(resp => {
          this.hideDialog()
          this.showMessage(['success', this.$t('success_message.tax_added_successfully')])
          this.$emit('onAdded', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    save () {
      this.isLoading = true
      const payload = {
        company: this.company.id,
        name: this.name,
        description: this.description,
        rate: this.rate
      }
      this.$axios.patch(`/tax_rates/${this.tax.id}`, payload)
        .then(resp => {
          this.hideDialog()
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
          this.$emit('onUpdated', resp.data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
